<td [ngClass]="{'light-green': materialHolder.selected && !conflict, 'dark-red': conflict}">
  @if (('material.transactions'|HasPerm)) {
    <a uiSref="a.material.inventory.update"
      target="_blank"
      [uiParams]="{variation: materialHolder.variation.id}"
      >
      {{materialHolder.variation.article.name}}
    </a>
  }
  @if (!('material.transactions'|HasPerm)) {
    {{materialHolder.variation.article.name}}
  }
</td>
@for (week of list; track week) {
  @for (title of week.title; track title; let i = $index) {
    <td class="align-right" [ngClass]="week.classes[i]" [title]="title">
      &nbsp;
    </td>
  }
}
